export const saveFilterToLocalStorage = (
  key: string, // local storage token key
  filters: Record<string, any>,
  allowedFilters: string[] // list of filter keys that will be saved in local storage
) => {
  const filtersToSave = Object.keys(filters)
    .filter((filterKey) => allowedFilters.includes(filterKey))
    .reduce(
      (obj, key) => ({
        ...obj,
        [key]: filters[key],
      }),
      {}
    );

  localStorage.setItem(key, JSON.stringify(filtersToSave));
};
